import { NavLink } from "react-router-dom";
import RouteConfig from "../../system/routes";
import { useEffect, useState } from "react";
import { typeConstants } from "../../constants";
import ProfileModal from "../../shared/Modals/ProfileModal";
import { clearStorage, getUserData } from "../../system";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const Sidebar = ({collapsed,setCollapsed}) => {
  const [screens, setScreens] = useState([]);

  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const Logout = () => {
    clearStorage();
    navigate("/login");
  };

  useEffect(() => {
    const decryptedData = getUserData();
    let filteredScreens;
    if (decryptedData.userTypeId == typeConstants.RECRUITER) {
      filteredScreens = RouteConfig.PrivateRoutes.filter(
        (x) => x.UserTypeId == typeConstants.RECRUITER
      );
    } else if (decryptedData.userTypeId == typeConstants.PLATFORM_ADMIN) {
      filteredScreens = RouteConfig.PrivateRoutes.filter(
        (x) => x.UserTypeId == typeConstants.PLATFORM_ADMIN
      );
    } else {
      filteredScreens = RouteConfig.PrivateRoutes.filter(
        (x) => x.UserTypeId == typeConstants.ALLOWED
      );
    }
    setScreens(filteredScreens);
  }, []);

  return (
    <div className={`app-menu navbar-menu ${collapsed ? "collapsed" : ""}`}>
      <ProfileModal showModal={showModal} setShowModal={setShowModal} />

      <div className="navbar-brand-box">
        <button
          className="sidebar-toggle text-light"
          onClick={() => setCollapsed(!collapsed)}
        >
          <i className="mdi mdi-menu" />
        </button>

        {!collapsed && (
          <NavLink to="/" className="logo logo-dark">
            <img src="assets/images/logo-dark.png" alt="demo" height={45} />
          </NavLink>
        )}
      </div>

      {/* menu list */}
      <div id="scrollbar" className="scroll-container">
        <div className="container-fluid pt-4 ps-0">
          <ul className="navbar-nav app-menu-list" id="navbar-nav">
            {screens.map((route, idx) => (
              <li className="nav-item" key={idx}>
                <NavLink
                  to={route.path}
                  end
                  className={({ isActive }) =>
                    `nav-link menu-link pill-link ${isActive ? "active" : ""
                    }`
                  }
                >
                  <i className={route.icon} />
                  {!collapsed && <span>{route.name}</span>}
                </NavLink>
              </li>
            ))}
          </ul>

          <ul
            className="navbar-nav app-menu-list bottom-fixed"
            id="navbar-nav"
          >
            <li className="nav-item" key="profile">
              <NavLink
                to=""
                onClick={() => setShowModal(true)}
                end
                className={({ isActive }) =>
                  `nav-link menu-link pill-link ${isActive ? "" : ""}`
                }
              >
                <i className="mdi mdi-account-circle" />
                {!collapsed && <span>Profile</span>}
              </NavLink>
            </li>

            <li className="nav-item" key="logout">
              <NavLink
                to=""
                onClick={() => Logout()}
                end
                className={({ isActive }) =>
                  `nav-link menu-link pill-link ${isActive ? "" : ""}`
                }              >
                <i className="mdi mdi-logout" />
                {!collapsed && <span>Logout</span>}
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
